import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
  TextField
} from "@mui/material";
import deletemodel from "../../../assets/deletemodel.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import CustomPasswordInput from "../../../components/PasswordInput";
const DeleteSettingsModal = ({ open, loading = false, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");

  const handleClose = () => {
    if (!loading) onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      disableEscapeKeyDown={loading}
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          p: 2,
          py: 1,
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(1px)" },
      }}
    >
      <DialogContent sx={{ pt: 3 }}>
        {/* Top icon */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <img src={deletemodel} alt="delete" style={{ width: 50, height: 50 }} />
        </Box>

        {/* Message */}
        <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 500,lineHeight:"32px", color: "#2C384C" }}>
  {t("deleteAccount.title")}          <br/>
     {t("deleteAccount.subtitle")}
        </CustomText>

        <label
  className="field-label"
  style={{ display: "block", textAlign: "left",paddingBottom:"10px" }}
>
          {t("deleteAccount.password")}</label>
         <CustomPasswordInput
                        name="password"
                         value={password}
          onChange={(e) => setPassword(e.target.value)}
                      />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 1.5,
          pb: 2.5,
          pt: 0,
        }}
      >
        {/* Cancel Button */}
        <CustomButton
          onClick={handleClose}
          disabled={loading}
          size="medium"
          label={t("logoutModel.cancel")}
          sx={{
            color: "#172B4D",
            backgroundColor: "white",
            "&:hover": { backgroundColor: "white", color: "#172B4D" },
          }}
        />

        {/* Delete Button */}
        <CustomButton
          onClick={() => onConfirm(password)}
          disabled={loading || !password}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {loading && (
                <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />
              )}
             {t("deleteAccount.delete")}
            </Box>
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSettingsModal;
